var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_411_408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0593 6L17.905 6.52414V21.7321L18.0593 21.886L25.1186 17.7133L18.0593 6Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0594 6L11 17.7133L18.0594 21.886V14.5045V6Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0594 23.2226L17.9724 23.3286V28.7459L18.0594 28.9998L25.1229 19.052L18.0594 23.2226Z",
    fill: "#3C3C3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0594 28.9998V23.2226L11 19.052L18.0594 28.9998Z",
    fill: "#8C8C8C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0593 21.886L25.1185 17.7133L18.0593 14.5045V21.886Z",
    fill: "#141414"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 17.7133L18.0594 21.886V14.5045L11 17.7133Z",
    fill: "#393939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_411_408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.1229,
    height: 23,
    fill: "white",
    transform: "translate(11 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.3d7759669d7d21457a1648d542599031.svg";
export { ForwardRef as ReactComponent };